import { formatCad } from "../../domain/format";
import { ratio, round } from "../../domain/funnel/stats";
import type { ChartBar } from "../common/FunnelChart";
import type { FunnelMode, FunnelReport } from "../types";

export const prospectingBars = (
  report: FunnelReport,
  previous: FunnelReport | null,
  label: (key: string) => string,
): ChartBar[] =>
  report.prospecting.map((step, i) => ({
    key: step.key,
    label: label(step.key),
    value: step.count,
    previous:
      previous?.prospecting.find((p) => p.key === step.key)?.count ?? null,
    conversion: i
      ? ratio(step.count, report.prospecting[i - 1].count, 4)
      : null,
    detail: "",
  }));

/** Cohort: bars = deals that reached the stage, conversion = RPC conv_next of the previous stage. Snapshot: current counts. */
export const dealBars = (
  report: FunnelReport,
  previous: FunnelReport | null,
  mode: FunnelMode,
  label: (stage: string) => string,
  color?: (stage: string) => string,
): ChartBar[] => {
  const rows = report.deals.filter((r) => r.stage !== "perdu");
  const value = (r: FunnelReport["deals"][number]) =>
    mode === "cohort" ? r.reached : r.count;
  return rows.map((row, i) => {
    const prev = previous?.deals.find((p) => p.stage === row.stage);
    return {
      key: row.stage,
      label: label(row.stage),
      value: value(row),
      previous: prev ? value(prev) : null,
      conversion: mode === "cohort" && i ? rows[i - 1].conv_next : null,
      detail: mode === "snapshot" ? formatCad(row.amount) : "",
      color: color?.(row.stage),
    };
  });
};

export const delta = (
  cur: number | null,
  prev: number | null,
): { diff: number | null; pct: number | null } =>
  cur == null || prev == null
    ? { diff: null, pct: null }
    : {
        diff: round(cur - prev, 4),
        pct: prev ? round((cur - prev) / prev, 4) : null,
      };
